module.exports = __webpack_public_path__ + "img/p15.c59191b3.jpg";